import dayjs from 'dayjs';
/**
 * Format currency amount to string
 */
export const formatCurrency = (amount, currency = 'USD') => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }).format(amount);
};
/**
 * Format date to locale string
 */
export const formatDate = (date, format, locale = 'en-US') => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (format) {
        return dayjs(dateObj).format(format);
    }
    // With dayjs, we can format a localized date string by setting the locale and applying a format.
    // We'll use 'll' (localized date string, e.g. Jan 1, 2023), falling back to en if needed.
    return dayjs(dateObj).locale(locale).format('ll');
};
/**
 * Format date for API (ISO string)
 */
export const formatDateForAPI = (date) => {
    return date.toISOString();
};
/**
 * Parse date from various formats
 */
export const parseDate = (dateString, format = 'MM/dd/yyyy') => {
    const parsed = dayjs(dateString, format);
    if (!parsed.isValid()) {
        throw new Error(`Invalid date: ${dateString}`);
    }
    return parsed.toDate();
};
/**
 * Generate a unique ID using crypto.randomUUID
 */
export const generateId = () => {
    return crypto.randomUUID();
};
/**
 * Validate email address
 */
export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
/**
 * Debounce function
 */
export const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};
/**
 * Calculate percentage
 */
export const calculatePercentage = (value, total) => {
    if (total === 0)
        return 0;
    return Math.round((value / total) * 100);
};
